// extracted by mini-css-extract-plugin
module.exports = {"form-bg":"LoginForm_form-bg__3G89R","bgImage":"LoginForm_bgImage__22lJG","invalid":"LoginForm_invalid__1BBt3"};